<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina-centrado">{{ 'SERVIDORALFRESCO.LBL_CONFIALFRESCO' | translate | titlecase }}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
    <button type="button" pButton icon="fa fa-plus" (click)="agregar()" *ngIf="menu.agregar"
      label="{{ 'BTN_AGREGAR' | translate }}"></button>
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
      (input)="dt.filterGlobal($event.target.value, 'contains')" [(ngModel)]="busqueda" (change)="setSearch()" />
  </div>
</div>

<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carSerAlfresco" #dt [rows]="regPorPagina"
      [value]="servidoresAlfresco" selectionMode="single" dataKey="idServidorAlfresco"
      [paginator]="true"  paginatorPosition="bottom" [globalFilterFields]="filtroBusqueda">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
            class="text-center">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td class="table-break">{{ row.fechaCreacion | date :'yyyy-MM-dd HH:mm:ss'}}</td>
          <td class="table-break">{{ row.nombre }}</td>
          <td class="table-break">{{ row.ruta }}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true"
              (onChange)="cambiarHabilitado(row, something)" #something></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                title="{{ 'BTN_EDITAR' | translate }}" pButton *ngIf="menu.editar" (click)="editar(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog #cd>
  <p-footer>
    <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate}}"
      (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>
